import React, { Component } from 'react';
import {
  Alert, Button, Spinner, Table, Modal,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import LanguageContext from "../../Layout/LanguageContext";
import { pageDict } from "../../Languages/PageTranslations";
import { Form } from './Form';
import { Details } from './Details';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { exportToExcel } from "../../Utils/ExportToExcel";
import { SamplesAPI } from "../../API";
import { SampleQuestionsList } from "./SampleQuestionsList";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';

const MODAL_TYPES = {
  NONE: 'NONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DETAILS: 'DETAILS',
  QUESTION: 'QUESTION',
  UPLOAD: 'UPLOAD' // Added UPLOAD modal type
};

type State = {
  status: PageStatus,
  error: string | null,
  formType: string,
  data: any[],
  id?: string | null,
  filteredData: any[],
  filters: {
    name: '',
  },
  pageSize: any,
  currentPageNumber: any,
  totalResponseData: any,
  totalResponsePages: any,
  loading: any,
  showUploadModal: boolean, // State for the upload modal visibility
  selectedFile: File | null, // State for the selected file
  jsonData: any[] | null, // Store JSON data in state
  samplename_newm: '', // Store sample name in state
  sampleDescription: '', // Store sample name in state

};

class SamplesComponent extends Component<any, any> {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      error: null,
      formType: MODAL_TYPES.NONE,
      data: [],
      id: null,
      filteredData: [],
      filters: {
        name: '',
      },
      pageSize: 10,
      currentPageNumber: 1,
      totalResponseData: '',
      totalResponsePages: '',
      loading: false,
      showUploadModal: false, // Initialize modal state
      selectedFile: null, // Initialize selected file
      jsonData: null, // Assuming you want to store this
      samplename_newm: '',
      sampleDescription: '', // New state for sample description
      sampleType: '',
      wholeElem: '',
    };
    this.fetchList = this.fetchList.bind(this);
  }
  //=========================== Method to open the upload modal =================================
  openUploadModal = () => {
    this.setState({ showUploadModal: true, status: PageStatus.Loaded, selectedFile: null, jsonData: null, samplename_newm: '', sampleDescription: '', sampleType: '', id: null, wholeElem: '' });
  };
  closeUploadModal = () => {
    this.setState({ showUploadModal: false, id: null, selectedFile: null, jsonData: null, samplename_newm: '', sampleDescription: '', sampleType: '' });
  };
  handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      // Check for valid CSV file type
      if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
        alert('Please upload a valid CSV file.');
        this.setState({ selectedFile: null }); // Reset selected file
        return;
      }

      // Store the file in the state
      this.setState({ selectedFile: file });
    }
  };
  handleSampleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ samplename_newm: event.target.value });
  };
  handleSampleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ sampleDescription: event.target.value });
  };

  convertCsvToBase64 = (file: File): Promise<any> => {
    const { samplename_newm, sampleDescription } = this.state;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const csvContent = typeof reader.result === 'string' ? reader.result : '';

        if (!csvContent.trim()) {
          reject(new Error('CSV content is empty.'));
          return;
        }

        if (file) {
          const reader = new FileReader();

          reader.onload = function (e) {
            const base64Encoded = e.target.result.split(',')[1];
            const formattedData = {
              sampleName: samplename_newm.trim() || '',
              sampleDescription: sampleDescription.trim() || '',
              details: base64Encoded
            };
            resolve(formattedData);
          };

          reader.onerror = (event) => {
            reject(new Error("FileReader encountered an error"));
          }

          reader.readAsDataURL(file);
        }
      };

      reader.onerror = (event) => {
        reject(new Error("FileReader encountered an error"));
      }

      reader.readAsText(file);
    });
  };

  // Method to handle file upload when clicking the "Upload" button
  handleUpload = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) {
      alert('Please select a file before uploading.');
      return;
    }

    try {
      const jsonData = await this.convertCsvToBase64(selectedFile);
      if (!jsonData.sampleName) {
        alert('Please enter sample name first.');
        return;
      }
      if (!jsonData.sampleDescription) {
        alert('Please enter sample description first.');
        return;
      }
      this.setState({ status: PageStatus.Loading })
      if (this.state.id) {
        jsonData.id = this.state.id;
        let apiResponse = await SamplesAPI.updateSampleUserMetdata(jsonData);
        this.setState({ id: apiResponse.id, status: PageStatus.Loaded });
        this.isShowDetailModal();
        alert('Sample updated successfully!');
      } else {
        let apiResponse = await SamplesAPI.uploadFileUniqueIds(jsonData);
        this.setState({ id: apiResponse.id, status: PageStatus.Loaded });
        this.isShowDetailModal();
        alert('Sample created successfully!');
      }
      this.setState({ sampleType: "uniqueIdSample" }, () => {
        this.fetchList();
        this.closeUploadModal();
      })
    } catch (error) {
      this.setState({ error: error.message, status: PageStatus.Error })
    }
  };

  componentDidMount() {
    this.fetchList()
  }

  fetchList(): Promise<void> {
    const { pageSize, currentPageNumber, filters } = this.state;
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => SamplesAPI.getAll(pageSize, currentPageNumber, filters))
      .then((countries) => {
        let responseData: any = countries;
        this.setState({ data: responseData.data, filteredData: responseData.data, totalResponseData: responseData.totalCount, totalResponsePages: responseData.totalPage, status: PageStatus.Loaded });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  isShowDetailModal(): boolean {
    return this.state.formType === MODAL_TYPES.DETAILS
      || this.state.formType === MODAL_TYPES.DELETE;
  }

  showHideUniqueModal = () => {
    this.setState((prevState) => {
      if (prevState.sampleType == "normal") {
        return {
          ...prevState,
          formType: MODAL_TYPES.UPDATE,
        };
      } else {
        return {
          ...prevState,
          showUploadModal: true,
          formType: MODAL_TYPES.NONE,
          selectedFile: null,
          jsonData: null,
          samplename_newm: prevState.wholeElem.name,
          sampleDescription: prevState.wholeElem.description,
        };
      }
    });
  };



  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
    );
  };

  applyFilters = () => {
    if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
    this.setState({ currentPageNumber: 1 })
  }


  clearFilter = async () => {
    await new Promise((resolve: any) =>
      this.setState({
        filters: {
          name: '',
        },
        pageSize: 10,
        currentPageNumber: 1,
        totalResponseData: '',
        totalResponsePages: ''
      }, resolve))
    this.fetchList()
  }

  async handleExport() {
    const { currentPageNumber, filters } = this.state;
    this.setState({ loading: true });
    try {
      const responseData = await SamplesAPI.getAll('All', currentPageNumber, filters);
      exportToExcel(responseData.data, 'Samples');
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  async downloadThisSample(id) {
    this.setState({ loading: true });
    try {
      // Server now streams binary Excel directly — receive as Blob and trigger save
      const blob: Blob = await SamplesAPI.getOneSampleUsersexportBlob(id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${id}_Sample_Data.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
  handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

  componentDidUpdate(prevProps: any, prevState: State) {
    if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
    if (prevProps.selectedCountry !== this.props.selectedCountry) {
      this.setState({ currentPageNumber: 1 }, () => this.fetchList());
    }
  };

  render() {
    const { filters, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
    const lang = this.context || 'en';
    const t = (key) => (pageDict[lang] && pageDict[lang][key]) || pageDict['en'][key] || key;
    return (
      <>
        <GridContainer>
          <div className='w-100 mb-3'>
            <CardHeader color="primary">
              <div className="d-flex align-items-center justify-content-between">
                <h4>{t("Samples")}</h4>
                <div>
                  {/* ====add functionalllity  here ONCLICK OPEN MODEL AND UPLOAD FILE ==== */}
                  <Button
                    variant="info"
                    size="sm"
                    className="mx-1"
                    onClick={this.openUploadModal} // Open modal on button click
                  >
                    <FontAwesomeIcon icon={['fas', 'upload']} className="mr-2" />
                    {t("Upload file")}
                  </Button>
                  {/* ========================================== */}
                  <Button
                    onClick={() => {
                      return this.setState({
                        formType: MODAL_TYPES.CREATE,
                      });
                    }}
                    variant="primary"
                    size="sm"
                    className="mx-1"
                  >
                    <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                    {t("Create")}
                  </Button>
                </div>
              </div>
            </CardHeader>
          </div>
        </GridContainer>
        {/* ========MODEL OPEN WILL BE HERE==== */}
        <Modal centered show={this.state.showUploadModal} onHide={this.closeUploadModal}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.wholeElem != "" ? t("Update Unique Sample") : t("Add Unique Sample")}</Modal.Title>
          </Modal.Header>
          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>
          <Show when={this.state.status !== PageStatus.Loading}>
            <Modal.Body>
              <div className='mb-2'>
                <label htmlFor="samplename">{t("Sample Name")}*</label>
                <input type="text" id="samplename_newm" className="form-control"
                  value={this.state.samplename_newm} onChange={this.handleSampleNameChange} // Update state with sample name input
                />
              </div>
              <div className='mb-2'>
                <label htmlFor="samplename">{t("Sample Description")}*</label>
                <textarea id="sampleDescription" className="form-control"
                  value={this.state.sampleDescription} onChange={this.handleSampleDescriptionChange} // Update state with sample description input
                />
              </div>
              <div className='mb-2'>
                <label htmlFor="samplename">{t("File userId")}*</label>
                <input type="file" className="form-control" accept=".csv" onChange={this.handleFileChange} />
                {this.state.selectedFile && (
                  <div>
                    <p><b>{t("File selected Name:")} </b>{this.state.selectedFile.name}</p>
                  </div>
                )}
              </div>


            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeUploadModal}>
                {t("Close")}
              </Button>
              <Button variant="primary" onClick={this.handleUpload}>
                {t("Upload")}
              </Button> {/* This button triggers the upload */}
            </Modal.Footer>
          </Show>
        </Modal>
        {/* =================================== */}
        <div className="jumbotron bg-white p-3 border shadow-sm">
          <div className='mb-3'>{t("Filter")}</div>

          <form>
            <div className="row">
              <div className="col">
                <label htmlFor='name'>{t("Name")}</label>
                <input type="text"
                  className="form-control"
                  placeholder={t("Enter...")}
                  name="name"
                  value={filters.name}
                  onChange={this.handleFilterChange}
                />
              </div>
            </div>
          </form>

          <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
            <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>{t("Filter Samples")}</button>
            <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>{t("Export")}</button>
            <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>{t("Clear Filter")}</button>
          </div>


        </div>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.formType === MODAL_TYPES.CREATE}>
            <Form
              show={this.state.formType === MODAL_TYPES.CREATE}

              onClose={() => this.setState({
                formType: MODAL_TYPES.NONE,
              })}
              onSubmit={(id, type) => {
                this.fetchList();
                this.setState({
                  formType: MODAL_TYPES.DETAILS, id: id, sampleType: type
                });
              }}
            />
          </Show>

          <Show when={this.state.status === PageStatus.Loaded}>
            <Show when={!this.state.filteredData.length}>
              <Alert variant="info" show={!this.state.filteredData.length}>
                {t("No data is available")}
              </Alert>
            </Show>

            <Show when={!!this.state.filteredData.length}>
              <Show when={this.isShowDetailModal()}>
                <Details
                  id={this.state.id}

                  onClose={() => this.setState({
                    formType: MODAL_TYPES.NONE,
                    id: null,
                  })}
                  onUpdate={() => {
                    this.showHideUniqueModal();
                  }}
                  onDelete={(id) => {
                    this.fetchList();
                    this.setState({
                      formType: MODAL_TYPES.NONE,
                      id: null,
                    });
                  }}
                />
              </Show>

              <Show when={this.state.formType === MODAL_TYPES.UPDATE}>
                <Form
                  show={this.state.formType === MODAL_TYPES.UPDATE}
                  id={this.state.id}

                  onClose={() => this.setState({
                    formType: MODAL_TYPES.NONE,
                    id: null,
                  })}
                  onSubmit={(id) => {
                    this.fetchList();
                    this.setState({
                      formType: MODAL_TYPES.DETAILS, id: id,
                    });
                  }}
                />
              </Show>

              <Show when={this.state.formType === MODAL_TYPES.QUESTION}>
                <SampleQuestionsList
                  show={this.state.formType === MODAL_TYPES.QUESTION}
                  id={this.state.id}

                  onClose={() => this.setState({
                    formType: MODAL_TYPES.NONE,
                    id: null,
                  })}
                  onSubmit={(id) => {
                    this.fetchList();
                    this.setState({
                      formType: MODAL_TYPES.DETAILS, id: id,
                    });
                  }}
                />
              </Show>
              <div className='mb-2'>
                <ShowDataAccording2PageSize
                  currentPageSize={pageSize}
                  currentPage={currentPageNumber}
                  sendPageSize={this.handlePageSizeChange}
                  showTotalData={totalResponseData}
                  sendLastPage={totalResponsePages}
                />
              </div>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                {this.state.loading && (
                  <img style={{ height: "415px", }}
                    src="../loadernew.gif"
                    alt="Loading..."
                  />
                )}
              </div>
              <Table responsive size="sm" bordered>
                <thead>
                  <tr>
                    <th>{t("S.No")}</th>
                    <th>{t("Unique ID")}</th>
                    <th>{t("Name")}</th>
                    <th>{t("Profile Count")}</th>
                    <th>{t("Active")}</th>
                    <th>{t("CreatedAt")}</th>
                    <th>{t("UpdatedAt")}</th>
                    <th>{t("Action")}</th>
                  </tr>
                </thead>

                <tbody>
                  {
                    this.state.filteredData.map((info, index) => (
                      <tr key={info.id}>
                        {/* <td>{index + 1}</td> */}
                        <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                        <td>{info.id}</td>
                        <td className='text-center'>
                          <button
                            type="button"
                            className="text-primary bg-transparent p-0 text-start d-block"
                            onKeyPress={() => null}
                            onClick={() => {
                              this.setState({
                                formType: MODAL_TYPES.DETAILS,
                                id: info.id,
                                sampleType: info.sampleType,
                                wholeElem: info,
                              });
                            }}
                            >
                            <div
                              style={{textAlign:"left", display:"block",whiteSpace:"normal"}}
                              dangerouslySetInnerHTML={{
                                __html: info.name || 'Title',
                              }}
                            >
                            </div>
                          </button>
                        </td>
                        <td>{info.profileCount}</td>
                        <td>{info.isActive === true ? t('Yes') : t('No')}</td>
                        <td>{moment(info.createdAt).format('MM/DD/YYYY HH:mm A')}</td>
                        <td>{moment(info.updatedAt).format('MM/DD/YYYY HH:mm A')}</td>
                        <td>
                          <div className='d-flex text-center'>
                            <div>
                              <div>
                                <button onClick={() => { this.downloadThisSample(info.id) }} className='bg-transparent'>
                                  <div
                                    className="text-primary bg-transparent"
                                    // This is the commented code can be used in future
                                    // onKeyPress={() => null}
                                    // onClick={() => {
                                    //   this.setState({
                                    //     formType: MODAL_TYPES.QUESTION,
                                    //     id: info.id,
                                    //   });
                                    // }}
                                  >Download</div>
                                  <i className='fa fa-download text-success align-item-center'></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>

              </Table>
              <div>
                <PaginationNumbering
                  currentPage={currentPageNumber}
                  returnPagenumber={this.handlePageNumberChange}
                  showTotalData={totalResponseData}
                  sendLastPage={totalResponsePages}
                />
              </div>
            </Show>
          </Show>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedCountry: state.adminUser.adminUser.selectedCountry,
});

const Samples = connect(mapStateToProps)(SamplesComponent);
export { Samples };
